<ion-header role="none">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        Close
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <h1 class="sr-only">{{ video.title }}</h1>
  <div class="video-modal-body">
    <ion-card-header class="ion-text-center">
      <ion-card-title aria-hidden="true">{{ video.title }}</ion-card-title>
    </ion-card-header>
    <ion-card>
      <div class="video-frame" [style.width.px]="vimeowidth()" [style.height.px]="vimeoheight()">
        <iframe *ngIf="isNativeIosApp; else standardFullscreenIframe"
          texttrack="EN" (load)="iframeLoaded($event)" id="iframe-video"
          [src]="vimeolink" frameborder="0"
          allow="autoplay; picture-in-picture; fullscreen; encrypted-media; playsinline"></iframe>
        <ng-template #standardFullscreenIframe>
          <iframe texttrack="EN" (load)="iframeLoaded($event)" id="iframe-video"
            mozallowfullscreen="true"
            webkitallowfullscreen="true"
            allowfullscreen="true"
            [src]="vimeolink" frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture; encrypted-media; playsinline"></iframe>
        </ng-template>
        <div class="videomodal-loader" *ngIf="showAjaxRequestLoader">
          <ion-spinner name="crescent" *ngIf="showSpinnerLoader"></ion-spinner>
        </div>
      </div>
    </ion-card>
    <app-video-instructions [videoWidth]="vimeowidth()"></app-video-instructions>
  </div>
</ion-content>
